import UploadAndSignDocument from './UploadAndSignDocument';

export default UploadAndSignDocument;
